import { useTranslation } from "react-i18next";

interface ConsentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  onReject: () => void;
}

const ConsentModal = ({ isOpen, onClose, onAccept, onReject }: ConsentModalProps) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="lg:w-[720px] w-full h-[718px] bg-white flex flex-col relative" onClick={(e) => e.stopPropagation()}>
        {/* Кнопка закрытия */}

        {/* Заголовок */}
        <div className="px-[50px] pt-[40px] pb-[5px]">
          <h3 className="text-red-900 text-xl font-medium font-['Inter'] leading-8">
            {t("consentModal.title")}
          </h3>
          <button
            onClick={onClose}
            className="absolute top-[40px] right-[40px] w-7 h-7 flex items-center justify-center cursor-pointer"
          >
            <div className="w-7 h-0.5 bg-red-900 rotate-45 absolute" />
            <div className="w-7 h-0.5 bg-red-900 -rotate-45 absolute" />
          </button>
        </div>

        {/* Текст согласия */}
        <div className="px-[50px] flex-1 overflow-y-auto">
          <div 
            className="text-neutral-800 text-sm font-light font-['Inter'] leading-4"
            dangerouslySetInnerHTML={{ __html: t("consentModal.text") }}
          />
        </div>

        {/* Кнопки */}
        <div className="px-[30px] pb-[40px] pt-[20px] flex flex-col lg:flex-row gap-[34px]">
          <button
            onClick={onAccept}
            className="w-full lg:w-80 h-16 bg-red-900 text-white text-lg font-medium font-['Inter'] leading-8 flex items-center justify-center cursor-pointer"
          >
            {t("consentModal.accept")}
          </button>
          <button
            onClick={onReject}
            className="w-full lg:w-80 h-16 border border-red-900 text-red-900 text-lg font-medium font-['Inter'] leading-8 flex items-center justify-center cursor-pointer"
          >
            {t("consentModal.reject")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;

